'use client';

import { useTranslation } from 'react-i18next';

export const HomeDashboard = () => {
  const { t } = useTranslation('my');

  return (
    <div className="HomeDashboard grid grid-cols-1 md:grid-cols-[2fr_1fr] gap-comfy-md items-start w-full">
      {/* Primary column — sponsorship cards, gift CTAs */}
      <section className="HomeDashboard__primary flex flex-col gap-comfy-sm">
        <h2 className="text-heading-sm font-bold">
          {t('homepage.dashboard.title')}
        </h2>
        <p className="text-body-sm text-neutral-600">
          {t('homepage.dashboard.subtitle')}
        </p>
        {/* Sponsorship cards and gift CTAs will render here */}
      </section>

      {/* Secondary column — letter activity, recent transactions, quick links */}
      <aside className="HomeDashboard__sidebar flex flex-col gap-comfy-sm">
        <div className="HomeDashboard__letter-activity rounded-lg border border-neutral-200 p-comfy-sm">
          <h3 className="text-heading-xs font-bold">
            {t('homepage.sidebar.letterActivity.title')}
          </h3>
          <p className="text-body-sm text-neutral-500 mt-comfy-2xs">
            {t('homepage.sidebar.letterActivity.subtitle')}
          </p>
          {/* Letter activity tracking card will render here */}
        </div>
      </aside>
    </div>
  );
};
